module.exports = __webpack_public_path__ + "img/3_24.01236014.png";